export default {
  accepted_message: "Your bet has been accepted.",
  waiting_message: "Your bet has been waiting.",
  login: "Login ဝင်ပါ...",
  password_rule: "* စကားဝှက်အား အကြီးအသေးနှင့် အနည်းဆုံး ၆ လုံးမှ ၁၀ လုံးထားပါ.",
  nickname_rule: "* သင်၏ Nick Name အား ၆လုံးမှ ၁၅ လုံးအထိနှင့် တစ်ကြိမ်သာ ထားရှိနိုင်သည်.",
  change_password_succeed: "စကားဝှက် ပြုပြင်ခြင်းအောင်မြင်သည်.",
  add_secondary_succeed: "Nick Name ပြုလုပ်ခြင်းအောင်မြင်သည်.",
  succeed: "သင်၏ လုပ်ဆောင်ချက် အောင်မြင်သည်!",
  failed: "သင်၏ လုပ်ဆောင်ချက် မအောင်မြင်ပါ!",
  no_information_available: "သတင်းအချက်အလက်မရှိပါ.",
  select_display_language: "အသုံးပြုလိုသည့် ဘာသာစကား ရွေးချယ်ပါ.",
  select_odds_type: "ကစားလိုသည့် ပေါက်ကြေးအမျိုးအစား ရွေးချယ်ပါ.",
  select_page_type: "ယနေ့ (သို့) မနက်ဖြန် ကစားမည့် စာမျက်နှာကို ရွေးချယ်ပါ.",
  select_show_score_map: "လောင်းထားသည့် ကစားပွဲများအား စနစ်မှ အနိုင်အရှုံးဖော်ပြချက်များကို ဇယားပုံနှင့်တကွ အလိုအလျောက် ပြသပေးမည်.",
  select_default_event_sorting: "အမြဲတမ်း ကစားမည့်ပွဲများကို ဦးစားပေးရွေးချယ်ပါ.",
  select_market_type: "သင်ကစားမည့် ပေါက်ကြေးအမျိုးအစားကို ရွေးချယ်ပါ.",
  select_page_size: "စာမျက်နှာ အရွယ်အစား ရွေးချယ်ပါ.",
  change_sports_menu_order: "ကိုယ်နှစ်သက်သည့် ပွဲစဥ်များအား ဖိထားပြီး အပေါ်အောက် ပြောင်းရွှေ့နိုင်သည် .",
  view_outstanding_bets_in_bet_list: "အသစ်ဆော့ထားသည့် ပွဲများ မပြီးဆုံးသေးပါက မိမ်၏ လောင်းကြေးဇယားတွင် ဝင်ရောက် ကြည့်ရှု့နိုင်သည်.",
  time_display_in_gmt_plus_8: "GMT+8 အချိန်ဖြင့် ဖော်ပြထားသည်.",
  select_default_stake: "မိမိလောင်းလိုသော ငွေပမာဏအား အမြဲတမ်းလောင်းကြေးငွေအဖြစ် သတ်မှတ်ထားနိုင်သည် ။ နောက်ဆုံးလောင်းထားသော လောင်းကြေးငွေကိုလဲ အမြဲတမ်းလောင်းကြေးငွေအဖြစ် သတ်မှတ်ထားနိုင်သည်။.",
  bet_empty: "လောင်းထားသော ကစားပွဲများ မရှိပါ ၊ ကျေးဇူးပြု၍ သင်လောင်းလိုသော ကစားပွဲအား ဇယားတွင် နှိပ်၍ လောင်းနိုင်ပါသည်.",
  no_event: "ကစားပွဲများမရှိသေးပါ ၊ ကျေးဇူးပြု၍ အခြားကစားနည်းများအား သွားရောက်ကစားပါ (သို့) နောက်မှပြန်လာပါ",
  no_bets: "လောင်းထားခြင်းမရှိပါ",
  no_waiting: "စောင့်ဆိုင်းနေသော လောင်းကြေးမရှိပါ",
  no_void: "ဖျက်သိမ်းခံရသော လောင်းကြေးမရှိပါ",
  confirmation: "‌လောင်းကြေးငွေထည့်ရန် သေချာပြီလား?",
  olderversion: "ဗားရှင်းအသစ်ထွက်ပါသဖြင့် Ok နှိပ်၍ အသစ်မြှင့်တင်ပါ (သို့) Ctrl +5 နှိပ်၍ မြှင့်တင်ပါ.",
  gmt8: "GMT+8 အချိန်ဖြင့် ဖော်ပြထားသည်.",
  no_betting_market: "No Betting Market",
  note_1: "The outstanding bets may take some time to process. Please go to My Bets to view your latest outstanding bets.",
  match_not_started: "ကစားပွဲ မစသေးပါ",

  banner1a: "PICK A SPORT",
  banner1b: "GET IN THE GAME",
  banner1c: "With a comprehensive selection of over 90 sports and thousands of live matches to bet on, the adrenalin rush never ends. Don’t miss out on your chance to win with our offer of only the best odds and top sports picks on the market.",
  banner2a: "ROLL THE DICE",
  banner2b: "HIT THE JACKPOT",
  banner2c: "Rake in winnings, all while enjoying a rich and immersive casino gaming experience at any of our luxurious suites. Take a seat, play your favourite casino game, and be on the receiving end of quality interaction from live dealers, all from the comfort of wherever you are.",
  banner3a: "GAMING AT ITS FINEST",
  banner3b: "A REVOLUTIONARY EXPERIENCE",
  banner3c: "An extensive selection of games, as far as the eye can see. Get a firsthand taste of it now.",
  banner4a: "OLYMPIC GAMES",
  banner4b: "TOKYO 2020",
  banner4c: "The 2020 Summer Olympics, officially the Games of the XXXII Olympiad and also known as Tokyo 2020, is an upcoming international multi-sport event scheduled to be held from 23 July to 8 August 2021 in Tokyo",
  banner4d: "We Bringing Back The EURO CUP 2020 For You!",
  banner5a: "LIVE SPORTS & GAME HIGHLIGHTS",
  banner5aa: "REACH YOUR COMMUNITY IN REAL TIME",
  banner5b: "Watch the best free Live TV and Highlights on the web and mobile devices",
  banner5c: "Get the latest sports scores anytime, anywhere",

  banner6a: "E-Fighting",
  banner6b: "Play the best fighting games",
  banner6c: "Collect your favorite characters, throw down in competitive combat, enter the battlefield and feel the fight! The more you play, the more you win!",

  banner7a: "NEW ESPORTS INTERFACE",
  banner7b: "ALL NEW EXPERIENCE",
  banner7c: "Extensive Choices of Esports markets, Industry Leading Betting Experience.",
  banner7d: "Popular massive multiplayer, Unbeatable odds & speedy settlement.",

  banner8a: "V-GAMES",
  banner8b: "PLAY THE GAMES, AND EXPERIENCE A DIFFERENT KIND OF VICTORY.",
  banner8c: "Experience a whole new level of victory.",
  banner8d: "Immerse yourself in a variety of games, from competitive to fighting, and explore new genres that wil keep you engaged for hours.",

  bannersb: "Enjoy non-stop thrills and excitement with an endless variety of sporting competitions to wager on, both locally and from all across the world. With us, you’ll always have the best odds.",
  bannersl: "Take a break from reality, step right through, and experience for yourself the fantasies that have been brought to life in our vividly detailed virtual games. You’re sure to get addicted. ",
  bannerlc: "Step inside any of our exclusive casino suites, indulge in your classic casino favourites, and lose yourself in an interactive experience featuring gorgeous live dealers.",

  banner10a: "Wishing you a great fun time",
  banner10b: "While you row to the rhythm of roaring drums!",

  banner11a: "FIFA WORLD CUP QATAR 2022 WORLD'S BIGGEST NATIONAL TEAM TOURNAMENT",
  banner11b: "The World Cup 2022 will take place in Qatar from 20 November to 18 December 2022",
  banner11c: "A total of 32 teams, including hosts Qatar, have qualified for the tournament, which will be the first time football’s biggest event takes place in the Middle East.",

  banner13a: "One team, one dream, to be crowned champions of the football tournament",
  banner13b: "Get ready for the ultimate display for skills, strategy, and passion as teams from all over the city battle it out in the annual football tournament. with thrilling matches and knockout rounds, anything can happen on the field. Join us for a fun day out and experience the excitement of the beautiful game!",

  banner15a: "Wishing you glorious",
  banner15b: "Happy Songkran Festival 2023",
  banner15c: "Whether you won or lost in past, it is not important. What is important is to keep moving ahead without giving up. Wbet wishing you glorious Happy Songkran Festival 2023 to you and your loved ones. Sawadee Pee Mai!!!",

  banner16a: "We wish you and your family a blessed Hari Raya Puasa!",
  // banner16b: "Happy Songkran Festival 2023",

  join_us1: "MAKE THIS YOUR WORLD",
  join_us2: "With 24/7 action and a spectacular array of products to wager on, we cater to pretty much any and all types of preferences. Plus, we’ve got cool bonuses, ongoing promotions, and efficient payouts to ensure you enjoy the best gaming experience. Take the first step and sign up with us now. It’s quick, easy, and free.",
  join_us3: "JOIN US NOW",

  icon1a: "OPTIMIZED FOR MOBILE",
  icon1b: "Our games are accessible on popular mobile platforms, so you can game on the go on your favourite device",
  icon2a: "ADVANCED SECURITY & SUPPORT",
  icon2b: "Enjoy our games and transact with us with true peace of mind – our website is fully secure to safeguard your privacy and personal info",
  icon3a: "IMMERSIVE EXPERIENCE",
  icon3b: "Indulgent, intuitive, and interactive – we have curated and selectively chosen premium products that will deliver the excitement you seek",
  icon4a: "CUSTOMER SUPPORT",
  icon4b: "Your satisfaction is our priority. We would to hear from you should you have any feedback or queries that would help us serve you better",
  footer1a: "Underage Gambling",
  footer1b: "Gambling is illegal for kids under the age of 18. Every state prohibits gambling by minors.{fvalue} will carry out age verification randomly and winnings will be forfeited if the gambler is below 18 years old.© 2004-2019. {fvalue} is An Internationally Registered Trademark (Licensed Sports Bookmaker). All Rights Reserved.",

  contactus_title1: "Customer Service specialists are available to answer all your questions including payment concerns in English and Chinese language.",
  contactus_title2: "International call charges may apply to you. Phone calls to us may be recorded for customer protection, information verification, quality assurance purposes and regulatory compliance.",

  days: "Days",
  hours: "Hours",
  mins: "Mins",
  secs: "Secs",
  ldiff_changed: "Percent has changed",
  no_room: "No room available. Please select other option and search again or come back later.",
  people_in_this_room: "People in this room",
  room_full: "This room is full",
  room_joined: "You have joined this room",
  my_room: "My Room",
  pin_code: "eg: 123456",
  no_matches: "No matches or games available now.",
  are_you_sure: "Are you sure to proceed this action?",
  accept_terms: "By ticking, you are confirming that you have read, understood and agree to the terms and conditions above.",
  accept_required: "Please read, understood and agree to the<br />terms and conditions above before proceeding.",
  must_accept_better_odds: "By default, place bet will auto accept better odds. Please refer to the Terms & Conditions for more information.",
  maintenance_notice: "Currently, we are performing system maintenance. Please try again later.",
  not_winning_prize_in_this_tournament: "Not winning prize in this tournament",
  you_did_not_join_this_room: "You did not join this room",
  deduct_confirm: "This will start the game and your credits will be deducted.<br />Are you sure to continue?",
  over_max_match: "The matches in this league exceed the maximum number of selectable matches.<br />Please expand the league and select the desired match.",

  //tournament
  button_skip: "Skip tour",
  button_previous: "Previous",
  button_next: "Next",
  button_stop: "Finish",
  button_continue: "Continue",
  tour_content_1: "<h6>Welcome to the WBET tournament</h6><p>We are pleased to announce an exciting new tournament exclusively for our site supporters.</p>",
  tour_content_2: "<h6>Public rooms</h6><p>Members engage in competitive gameplay against each other, usually with an entry fee.</p>",
  tour_content_3: "<h6>Private rooms</h6><p>Members can open rooms to play with friends by utilizing an invited pin for entry.</p>",
  tour_content_4: "<h6>Public free rooms</h6><p>Organized by various organizations during special events exclusively for members, offering free participation.</p>",
  tour_content_5: "<h6>Total player can join & charges</h6><p>Players : Capacity of the room.</p><p>Entry Fee: Base by Rooms offer ( Currency Of the Account Holder).</p>",
  tour_content_6: "<h6>Room details</h6><p>Click here to preview the room statics and join the room.</p>",
  tour_content_7: "<h6>Pools details</h6><p>Total Pool prizes for winner  & Unique room ID to search.</p>",
  tour_content_8: "<h6>Room start details</h6><p>Room status & Last join time display.</p>",
  tour_content_9: "<h6>Private room create</h6><p>To Create private room play and invited friends to join by pin for entry.</p>",
  tour_content_10: "<h6>Points Ranking</h6><p>This feature is to display the points for the player viewing and tracking the result.</p>",

  time_machine_information_HDP: "WBET Time Machine [HDP] သည် ရွေးချယ်ထားသော ကာလအတွင်း မည်သည့်အသင်းသည် ဂိုးအများဆုံးသွင်းယူမည်ကို ခန့်မှန်းရန်ဖြစ်သည်။ ",
  time_machine_information_OU: "WBET Time Machine [OU] သည် ရွေးချယ်ထားသော ကာလအတွင်း ဂိုးစုစုပေါင်းအရေအတွက်ကို ခန့်မှန်းရန်ဖြစ်သည်။"
};
